
import { Fragment } from "react"
import Header from "../components/Header"
import Chatwindow from "../components/Chatwindow"
const ChatView=()=>{
    return <Fragment>
        <div className="w-full h-full overflow-x-hidden ">

        <Header/>

        <Chatwindow/>

        </div>
        
    </Fragment>
}

export default ChatView